"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _headRow = _interopRequireDefault(require("./rows/head-row"));
var _bodyRow = _interopRequireDefault(require("./rows/body-row"));
var _footRow = _interopRequireDefault(require("./rows/foot-row"));
/**
 * Local Imports
 */

/**
 * RowItem Component.
 *
 * @param {Object} props React props
 * @param {Array} props.items Array of column items
 * @param {String} props.rowType Row type [header, body, footer]
 * @returns {React.ReactElement} RowItem Component
 * @public
 */

function RowItem({
  items,
  rowType,
  ...rest
}) {
  switch (rowType) {
    case 'header':
      return /*#__PURE__*/_react.default.createElement(_headRow.default, (0, _extends2.default)({
        items: items
      }, rest));
    case 'body':
      return /*#__PURE__*/_react.default.createElement(_bodyRow.default, (0, _extends2.default)({
        items: items
      }, rest));
    case 'footer':
      return /*#__PURE__*/_react.default.createElement(_footRow.default, (0, _extends2.default)({
        items: items
      }, rest));
    default:
      return null;
  }
}
var _default = exports.default = RowItem;
RowItem.propTypes = {
  items: _propTypes.default.array,
  rowType: _propTypes.default.oneOf(['header', 'body', 'footer'])
};